import _extends from "@babel/runtime/helpers/extends";
import React, { useMemo } from 'react';
import { ErrorScreen } from './ErrorScreen';
import { LoginPage } from './LoginPage';
import { StorageAccessPage } from './StorageAccessPage';
import { useUrl } from './useUrl';
import { useValidationState, Subjects, LoadingStatus } from './useValidationState';
var noop = function noop() {};
export var PageLoadValidation = function PageLoadValidation(props) {
  var _useUrl = useUrl(props),
    standaloneConfluenceUrl = _useUrl.standaloneConfluenceUrl,
    embeddedConfluenceUrl = _useUrl.embeddedConfluenceUrl,
    formattedLocale = _useUrl.formattedLocale;
  var isEmbeddedUrlOnSameDomain = embeddedConfluenceUrl ? window.location.origin === new URL(embeddedConfluenceUrl).origin : false;
  return isEmbeddedUrlOnSameDomain ? props.children({
    handleIframeOnLoad: noop,
    handleContentLoadStarted: noop,
    handleIframeUnload: noop,
    navigationPolicy: props.navigationPolicy
  }) : /*#__PURE__*/React.createElement(CrossDomainErrorValidation, _extends({
    key: embeddedConfluenceUrl || props.contentId,
    standaloneConfluenceUrl: standaloneConfluenceUrl,
    embeddedConfluenceUrl: embeddedConfluenceUrl,
    allowedFeatures: props.allowedFeatures,
    formattedLocale: formattedLocale
  }, props));
};
var CrossDomainErrorValidation = function CrossDomainErrorValidation(_ref) {
  var _allowedFeatures$incl;
  var allowedFeatures = _ref.allowedFeatures,
    children = _ref.children,
    contentId = _ref.contentId,
    embeddedConfluenceUrl = _ref.embeddedConfluenceUrl,
    formattedLocale = _ref.formattedLocale,
    navigationPolicy = _ref.navigationPolicy,
    parentProduct = _ref.parentProduct,
    spaceKey = _ref.spaceKey,
    standaloneConfluenceUrl = _ref.standaloneConfluenceUrl;
  var _useValidationState = useValidationState(),
    state = _useValidationState.state,
    dispatch = _useValidationState.dispatch;
  var iframeLoaded = state.iframeLoaded,
    contentLoadStarted = state.contentLoadStarted,
    shouldAskStorageAccess = state.shouldAskStorageAccess,
    shouldAskToLogin = state.shouldAskToLogin,
    redirectedToLogin = state.redirectedToLogin,
    iframeUnloaded = state.iframeUnloaded;
  var isLoginFlowDisabled = (_allowedFeatures$incl = allowedFeatures === null || allowedFeatures === void 0 ? void 0 : allowedFeatures.includes('disable-login-flow')) !== null && _allowedFeatures$incl !== void 0 ? _allowedFeatures$incl : false;
  var reloadEP = function reloadEP() {
    dispatch({
      subject: Subjects.CONTENT_LOAD,
      status: LoadingStatus.RELOAD_EP
    });
  };
  var failToLoad = iframeLoaded && !contentLoadStarted ||
  /*
    If anonymous access is permitted globally but restricted on a content's parent space,
    the iframe will attempt a login redirect which we intercept.
    To avoid an error in the iframe, we need to wait for the iframe window to unload
    before unmouting the Iframe component.
  */
  iframeUnloaded && redirectedToLogin;
  var pageNavigationPolicy = useMemo(function () {
    return {
      navigate: function navigate(url, modifiers, defaultNavigate) {
        // modifiy the navigationPolicy to intercept login redirects
        // so that login can be handled outside of the iframe
        if (url.includes('/login?application=confluence')) {
          dispatch({
            subject: Subjects.CONTENT_LOAD,
            status: LoadingStatus.REDIRECTED_TO_LOGIN
          });
          return;
        }
        return navigationPolicy !== null && navigationPolicy !== void 0 && navigationPolicy.navigate ? navigationPolicy.navigate(url, modifiers, defaultNavigate) : defaultNavigate(url, modifiers);
      },
      shimUrl: navigationPolicy === null || navigationPolicy === void 0 ? void 0 : navigationPolicy.shimUrl,
      domainNamesToReplace: navigationPolicy === null || navigationPolicy === void 0 ? void 0 : navigationPolicy.domainNamesToReplace
    };
  }, [navigationPolicy, dispatch]);
  if (!failToLoad) {
    return children({
      handleIframeOnLoad: function handleIframeOnLoad() {
        dispatch({
          subject: Subjects.CONTENT_LOAD,
          status: LoadingStatus.IFRAME_LOADED
        });
      },
      handleContentLoadStarted: function handleContentLoadStarted() {
        dispatch({
          subject: Subjects.CONTENT_LOAD,
          status: LoadingStatus.CONTENT_LOAD_STARTED
        });
      },
      handleIframeUnload: function handleIframeUnload() {
        dispatch({
          subject: Subjects.CONTENT_LOAD,
          status: LoadingStatus.IFRAME_UNLOADED
        });
      },
      navigationPolicy: pageNavigationPolicy,
      redirectedToLogin: redirectedToLogin
    });
  }
  if (!isLoginFlowDisabled) {
    if (shouldAskStorageAccess) {
      return /*#__PURE__*/React.createElement(StorageAccessPage, {
        url: embeddedConfluenceUrl,
        contentId: contentId,
        spaceKey: spaceKey,
        parentProduct: parentProduct,
        formattedLocale: formattedLocale
      });
    }
    if (shouldAskToLogin) {
      return /*#__PURE__*/React.createElement(LoginPage, {
        contentId: contentId,
        reloadEP: reloadEP,
        spaceKey: spaceKey,
        url: embeddedConfluenceUrl,
        formattedLocale: formattedLocale
      });
    }
  }
  return /*#__PURE__*/React.createElement(ErrorScreen, {
    standaloneConfluenceUrl: standaloneConfluenceUrl
  });
};